import React from 'react'
import PropTypes from 'prop-types'
import CardListItem from './CardListItem'
import styles from './ResponsiveTable.module.scss'

/**
 * CardList - Renders an array of CardListItem components for mobile layout.
 */
const CardList = ({
  data,
  columns,
  priorityConfig,
  onRowClick
}) => {
  return (
    <div className={styles.cardList}>
      {data.map((row, index) => (
        <CardListItem
          key={`card-${index}-${row.id || row.call_id || ''}`}
          row={row}
          rowIndex={index}
          columns={columns}
          priorityConfig={priorityConfig}
          onRowClick={onRowClick}
        />
      ))}
    </div>
  )
}

CardList.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  priorityConfig: PropTypes.object.isRequired,
  onRowClick: PropTypes.func
}

export default React.memo(CardList)
